import './MediaPartners.scss';
import slotyi from '../../../../../assets/images/slotyi.png';
import allianz from '../../../../../assets/images/allianz.png';
import slotCatalog from '../../../../../assets/images/slot-catalog.png';

export const MediaPartners = () => {
  return (
    <div className="media-partners">
      <h2 className="mb-5 text-white text-center">Media Partners</h2>
      {/*<h2 className="media-partners-title">Media Partners</h2>*/}
      <div className="media-partners-logos">
        <a href="https://slotcatalog.com/en" target="_blank" rel="noopener noreferrer">
          <img src={slotCatalog} alt="Slot Catalog" className="media-partner-logo"/>
        </a>
        <a href="https://www.slotyi.com" target="_blank" rel="noopener noreferrer">
          <img src={slotyi} alt="Slotyi" className="media-partner-logo"/>
        </a>
        <a href="https://casinoallianz.com/" target="_blank" rel="noopener noreferrer">
          <img src={allianz} alt="Allianz" className="media-partner-logo"/>
        </a>
      </div>
    </div>
  );
}